define([
	"dojo/_base/declare",
	"./NewFoodSourceSamples",
	"./_NewFormulatedProductMixin"
], function(declare,NewFoodSourceSamples,_NewFormulatedProductMixin) {

	return declare([NewFoodSourceSamples, _NewFormulatedProductMixin], {
		/**
		 * @override
		 * initialize designated supplier, product and SizeOwner on samples form
		 */
		onCreatePopup: function(view) {
			const parent = this.getParent();
			const dps = parent && this.getCache().getPathNode(parent, "Child:ProductSourcing/Child:DesignatedProductSource");
			// make sure the designated Supplier is visible
			if (dps && this.getCache().getNode(dps.Supplier)) {
				view.addDefaultValue("Supplier", [dps.Supplier]);
			}
			const viewNode = this.widget.getViewNode();
			view.setProduct(viewNode);
		}
	});
});
